import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchConversionStatsData } from '../../api/subscription';
import { Box, Grid, Typography } from "@mui/material";

const MetricCardGrid = ({ title,total, value,percentage, subtitle }) => (
  <Box
    border="1px solid #eee"
    borderRadius={2}
    p={2}
    height={130}
    display="flex"
    flexDirection="column"
    justifyContent="center"
  >
    <Typography fontWeight="500" color="#3E3E3E" fontSize={16} mb={2} sx={{ fontSize: '16px', color: '#3E3E3E', display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
      {title}  
      {/* <Typography variant="span" sx={{ background: '#C2E4D1', color: '#008E40', fontSize: '14px', borderRadius: '4px', display: 'inline-block', padding: '3px 10px', }}>{percentage}%</Typography> */}
    </Typography>
    <Typography fontSize={24} color="#3C4043" fontWeight={600}>
      {value}
    </Typography>
    <Typography fontSize={14} color="#757575">
      {subtitle}
    </Typography>
  </Box>
);

const NewMetricCard = () => {
    const [metrics, setMetrics] = useState([]);
    // const { filter } = useSelector((state) => state);
      const filter = useSelector((state) => state.filter);
      const filterWithoutUTM = useMemo(() => {
        const { utm_options, ...rest } = filter;
        return rest;
      }, [JSON.stringify(filter)]);
  
    const fetchData = async () => {
      try {
        await fetchConversionStatsData(filter, setMetrics);
      } catch (error) {
        console.error('Error while loading real-time data', error);
      }
    };
  
    useEffect(() => {
      fetchData();
    }, [JSON.stringify(filterWithoutUTM)]);
  return (
    <Box p={2} mt={2} sx={{ boxShadow: "none", border: "1px solid #e6e6e6", borderRadius: "20px", p: 2 }}>
      <Typography fontWeight="500" fontSize={20} color="#3C4043" mb={2}>
        Conversion Metrics
      </Typography>
      <Grid container spacing={2}>
        {metrics.map((metric, index) => (
        <Grid item xs={12} key={index} sm={6}>
          <MetricCardGrid
            title={metric.title}
            value={metric.change}
            total={metric.total}
            subtitle={metric.details}
          />
        </Grid>
        ))}
        {/* <Grid item xs={12} sm={6}>
          <MetricCardGrid
            title="Free to Paid User Conversion"
            value="80K"
            subtitle="of 250k free users converted to premium"
          />
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default NewMetricCard;
